// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3JUXq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2rGqo"};